@if (versionInfo) {
  <div class="text-small-extra app-version break-word" data-role="app-version">
    @if (!versionInfo.isOutdated) {
      <a
        class="link-version"
        matTooltip="Click to check now if there is a new version."
        (click)="checkIsOutdated()"
        >{{ versionInfo?.localVersion }}<mat-icon>check</mat-icon>
      </a>
    }
    @if (versionInfo.isOutdated) {
      <a
        class="link-version"
        matTooltip="There is a new version of the application ({{
          versionInfo.latestVersion
        }}). Click to update it."
        (click)="updateApp()"
        >{{ versionInfo?.localVersion }}<mat-icon>warning</mat-icon>
      </a>
    }
  </div>
}
